/*
 * @Author: wzh
 * @LastEditTime: 2022-11-01 14:06:11
 * @Description: 帮助文档 index
 */
import HelpDocument from "./HelpDocument.vue";

export { HelpDocument };
